import { render, staticRenderFns } from "./Employment-Status.vue?vue&type=template&id=6861bfc0"
import script from "./Employment-Status.vue?vue&type=script&lang=js"
export * from "./Employment-Status.vue?vue&type=script&lang=js"
import style0 from "./Employment-Status.vue?vue&type=style&index=0&id=6861bfc0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports